
(function () {
  function mpS() {
    var mq = document.getElementById('mq');

    if (!mq) return false;
    if (mq.dataset.mps) return true;

    mq.dataset.mps = '1';

    var css = `
      #mq {
        background: transparent !important;
        padding: 0 !important;
        margin-top: 4px !important;
        box-shadow: none !important;
        border: 0 !important;
      }

      #mq .mq-h,
      #mq .mq-opt,
      #mq .mq-t {
        display: none !important;
      }

      .product-information:has(#mq) {
        row-gap: 6px !important;
      }

      #mqBtns {
        display: flex !important;
        flex-direction: column !important;
        gap: 4px !important;
      }

      #mq .mq-go.cod {
        order: 1;
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        min-height: 60px !important;
        border-radius: 999px !important;
        background: #b3261e !important;
        color: #fff !important;
        font-weight: 800 !important;
        font-size: 20px !important;
        line-height: 1.15 !important;
        text-decoration: none !important;
        border: 0 !important;
      }

      #mq .mq-go.cod small {
        display: block;
        font-size: 12px;
        font-weight: 700;
        opacity: .92;
      }

      #mq .mq-go.card {
        order: 2;
        background: none !important;
        border: 0 !important;
        box-shadow: none !important;
        color: #1f2d5c !important;
        font-size: 13px !important;
        font-weight: 700 !important;
        text-decoration: underline !important;
        min-height: 0 !important;
        padding: 6px !important;
        text-align: center !important;
      }

      .mp-ben {
        font-size: 14px;
        font-weight: 600;
        color: #4a5470;
        margin: 0 0 10px;
      }

      .mp-gal {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-top: 8px;
        padding: 10px 12px;
        border-radius: 12px;
        background: #eef3fd;
        font-size: 13px;
        font-weight: 700;
        color: #1f2d5c;
        line-height: 1.25;
      }

      .mp-gal img {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        object-fit: cover;
        flex-shrink: 0;
      }

      .mp-tr {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 6px;
        margin-top: 10px;
        font-size: 11px;
        font-weight: 700;
        color: #4a5470;
        text-align: center;
      }

      @media (max-width: 749px) {
        html body .mp-th {
          display: none !important;
        }

        html body media-gallery slideshow-component,
        html body media-gallery slideshow-container,
        html body media-gallery slideshow-slides,
        html body media-gallery slideshow-slide,
        html body media-gallery .product-media-container,
        html body media-gallery .product-media {
          height: auto !important;
          max-height: none !important;
          aspect-ratio: 1 / 1 !important;
        }

        html body media-gallery img.product-media__image {
          height: 100% !important;
          object-fit: contain !important;
        }
      }
    `;

    var st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);

    var btns = document.getElementById('mqBtns');

    var cod = mq.querySelector('.mq-go.cod');

    if (cod) {
      cod.innerHTML =
        'Comprar<small>Pagas al recibirlo · Envío gratis</small>';
    }

    var card = mq.querySelector('.mq-go.card');

    if (card) {
      card.textContent = 'o paga con tarjeta';
    }

    var b = document.createElement('p');
    b.className = 'mp-ben';
    b.textContent =
      '';

    mq.insertBefore(b, btns);

    var gi = mq.querySelectorAll('.mq-opt img')[1];

    var g = document.createElement('div');
    g.className = 'mp-gal';

    g.innerHTML =
      (gi ? '<img src="' + gi.src + '" alt="">' : '') +
      '<span>¿Efecto galaxia en el techo? Podrás añadir el proyector de estrellas al hacer el pedido.</span>';

    btns.after(g);

    var t = document.createElement('div');
    t.className = 'mp-tr';

    
    
    g.after(t);

    return true;
  }

  if (!mpS()) {
    document.addEventListener('DOMContentLoaded', mpS);
  }
})();


// Cerrar automáticamente los desplegables al pulsar fuera
(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [
      ...document.querySelectorAll(
        'details[data-auto-close-details][open]'
      )
    ].filter((element) => {
      const closingOn =
        window.innerWidth < 750 ? 'mobile' : 'desktop';

      return (
        element
          .getAttribute('data-auto-close-details')
          ?.includes(closingOn) &&
        !(event.target instanceof Node &&
          element.contains(event.target))
      );
    });

    for (const detailsElement of detailsToClose) {
      detailsElement.removeAttribute('open');
    }
  });
})();

(function(){if((location.pathname==='/'||location.pathname==='')&&!(window.Shopify&&Shopify.designMode)){location.replace('/products/humidificador-nave-astronauta-usb'+location.search);return;}var s=document.createElement('style');s.textContent='#easysell .es-p-discounts{display:none!important}';document.head.appendChild(s);})();
